// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"ProductFiltersBase_switchContainer_2528w"};